<form [formGroup]="formGroup">
  @if (displayField()) {
    <div>
      @if (correctionData.propertyType === 'array' || correctionData.propertyType === 'object') {
        <div>
          <hr>
            <h4>{{correctionData.propertyDisplayName}}</h4>
            @if (isArrayEntry && !isInReviewMode) {
              <button (click)="onRemoveArrayEntryClick(arrayPosition)" attr.aria-label="Remove Item From Array"><svg-icon icon="icon-minus" aria-hidden="true" class="dark-gray float-right cursor-pointer"></svg-icon>Remove the current Array Item</button>
            }
            @if (itemIsAdded) {
              <span class="bold red padding-left">New Item in Array</span>
            }
            @if (itemIsRemoved) {
              <span class="bold red padding-left">Item to be Removed @if (!isInReviewMode) {
                <span class="padding-left"><button class="button" id="undo" aria-describedby="undoButton" (click)="undoRemove()">Undo</button></span>
              }</span>
            }
            <span class="show-for-sr">Undo Remove of {{correctionData.propertyDisplayName}}</span>
          </div>
        }
        @if (correctionData.propertyType !== 'array' && correctionData.propertyType !== 'object') {
          <div>
            {{correctionData.propertyDisplayName}}
            @if (itemIsAdded) {
              <span class="bold red padding-left">New Item in Array</span>
            }
            @if (itemIsRemoved) {
              <span class="bold red padding-left">Item to be Removed@if (!isInReviewMode) {
                <span class="padding-left"><button class="button" id="undo" aria-describedby="undoButton" (click)="undoRemove()">Undo</button></span>
              }</span>
            }
            @if (isArrayEntry && !isInReviewMode && !itemIsRemoved) {
              <button (click)="onRemoveArrayEntryClick()" attr.aria-label="Remove Item From Array"><svg-icon icon="icon-minus" aria-hidden="true" class="dark-gray float-right cursor-pointer"></svg-icon>Remove the current Array Item</button>
            }
          </div>
        }
        @if (isSimpleType()) {
          <div class="grid-x">
            <div class="cell small-6">
              @if (correctionData.propertyType === 'string') {
                <div>
                  @if (correctionData.propertyFormat ==='date-time' || correctionData.propertyFormat ==='date') {
                    <div>
                      <div>
                        <input class="no-margin" id={{correctionData.propertyId}} type="date" [formControlName]="correctionData.propertyId" />
                      </div>
                    </div>
                  }
                  @if (correctionData.propertyFormat !=='date-time' && correctionData.propertyFormat !=='date') {
                    <div>
                      <div>
                        <input id={{correctionData.propertyId}} type="text" [formControlName]="correctionData.propertyId" />
                      </div>
                    </div>
                  }
                </div>
              }
              @if (correctionData.propertyType === 'boolean') {
                <div>
                  <div>
                    <input class="no-margin" type="checkbox" [formControlName]="correctionData.propertyId" [(checked)]="correctionData.propertyValue" />
                  </div>
                </div>
              }
              @if (correctionData.propertyType === 'number') {
                <div>
                  <div>
                    <input class="no-margin" type="number" [formControlName]="correctionData.propertyId" />
                  </div>
                </div>
              }
              @if (correctionData.propertyType === 'integer') {
                <div>
                  <div>
                    <input class="no-margin" type="number" [formControlName]="correctionData.propertyId"
                      oninput="this.value = Math.round(this.value);" min="0" step="1">
                    </div>
                  </div>
                }
              </div>
              <div class="cell small-6">
                @if (fieldHasBeenEdited() && isInReviewMode) {
                  <div class="relative">
                    <span (mouseover)="toggleShowInitialValue(correctionData.propertyDataSource, true)" (mouseout)="toggleShowInitialValue(correctionData.propertyDataSource, false)">
                      <svg-icon aria-hidden="true" icon="icon-delta" class="tiny light-blue"></svg-icon>
                    </span>
                    <span [ngClass]="showInitialValues[correctionData.propertyDataSource] ? 'show-full-text' : 'hide-full-text'">{{getFieldOriginalValue(correctionData.propertyDataSource)}}</span>
                  </div>
                }
              </div>
            </div>
          }
          @if (!isSimpleType()) {
            <div>
              @if (correctionData.propertyType === 'object') {
                <div style="margin-left:5%">
                  @for (childModel of correctionData.childCorrectionModels; track childModel) {
                    <div>
                      <data-correction-input [isInReviewMode]="isInReviewMode" [correctionData]="childModel" [correctionDataInstance]="correctionDataInstance"
                        [formGroup]="getChildFormGroup()" [showOnlyAlteredFields]="showOnlyAlteredFields" [parentModel]="correctionData"
                      (correctionDataArrayChanged)="onCorrectionDataArrayChanged($event)"></data-correction-input>
                    </div>
                  }
                </div>
              }
              @if (correctionData.propertyType === 'array') {
                <div style="margin-left:5%">
                  @for (childModel of correctionData.childCorrectionModels; track childModel) {
                    <div>
                      <data-correction-input [isInReviewMode]="isInReviewMode" [correctionData]="childModel" [correctionDataInstance]="correctionDataInstance"
                        [formGroup]="getChildFormGroup()" [isArrayEntry]="true" [showOnlyAlteredFields]="showOnlyAlteredFields" [parentModel]="correctionData"
                      (correctionDataArrayChanged)="onCorrectionDataArrayChanged($event)"></data-correction-input>
                    </div>
                  }
                  @if (!isInReviewMode) {
                    <div class="cell">
                      <button (click)="onAddArrayEntryClick()" attr.aria-label="Add New Item To Array"><svg-icon icon="icon-plus" aria-hidden="true" class="dark-gray float-right cursor-pointer"></svg-icon>Add a new item to the array.</button>
                    </div>
                  }
                </div>
              }
              <hr>
              </div>
            }
          </div>
        }
      </form>


